export class BuildVersion { public static readonly buildVersion = 'development'; }
